import React from 'react'


function Pricing() {
    return ( 
        <div className='container'>
            <div className='row'>
                <div className='col-4'>
                    <h2 className='mb-3'>Unbeatable Pricing</h2>
                    <p>We pioneered the concept of discount broking and price transparency in India. Flat fees and no hidden charges.</p>
                    <a href='#'>See Pricing</a>
                </div>
                <div className='col-6 mx-5'style={{display:"flex",justifyContent:'space-evenly'}} >
                    <div className='col-2'> <img src='media/pricing.svg' alt='pricing' ></img>
                        <p>Free Account Opening</p>
                    </div>
                    <div className='col-2'> <img src='media/pricing.svg' alt='pricing' ></img>
                        <p>Free equity delivery
                        and direct mutual funds</p>
                    </div>
                    <div className='col-2'> <img src='media/pricing20.svg' alt='pricing' ></img>
                        <p>Intraday and
                        F&O</p>
                    </div>
                    
                </div>

            </div>
        </div>
     );
}

export default Pricing;